(() => {
  let queued = false;

  function ensureFooterStyles() {
    if (document.getElementById('lurello-cart-footer-cleanup')) return;

    const style = document.createElement('style');
    style.id = 'lurello-cart-footer-cleanup';
    style.textContent = `
      #CartDrawer .cart__ctas {
        display: block !important;
        width: 100% !important;
      }

      #CartDrawer .cart__ctas::after {
        content: none !important;
        display: none !important;
      }

      #CartDrawer .cart__checkout-button {
        display: flex !important;
        width: 100% !important;
        max-width: none !important;
        align-items: center !important;
        justify-content: center !important;
      }

      #CartDrawer .lurello-cart-total-new {
        font-family: var(--font-body-family) !important;
        font-size: 16px !important;
        line-height: 1.15 !important;
        font-weight: 700 !important;
      }
    `;
    document.head.appendChild(style);
  }

  function addVisuallyHidden(parent, text) {
    const node = document.createElement('span');
    node.className = 'visually-hidden';
    node.textContent = text;
    parent.appendChild(node);
  }

  function polishCartUi(drawer) {
    const removableOptionLabels = new Set([
      'color', 'colour', 'farbe',
      'stil', 'style',
      'größe', 'grosse', 'size',
      'material',
      'muster', 'pattern',
      'motiv', 'motif',
      'variante', 'variant'
    ]);

    drawer.querySelectorAll('.cart-item__details dt').forEach((label) => {
      const normalized = label.textContent.replace(/:$/, '').trim().toLowerCase();
      if (!removableOptionLabels.has(normalized)) return;

      const value = label.parentElement?.querySelector('dd');
      if (value) value.style.marginInlineStart = '0';
      label.remove();
    });

    const checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout) {
      checkout.textContent = 'Zur Kasse';
      checkout.setAttribute('aria-label', 'Zur Kasse');
    }
  }

  function styleSimpleTotal(totalsRow, totalLabel, totalValue) {
    if (!totalsRow) return;

    totalsRow.style.display = 'flex';
    totalsRow.style.alignItems = 'baseline';
    totalsRow.style.justifyContent = 'space-between';
    totalsRow.style.gap = '12px';
    totalsRow.style.flexWrap = 'nowrap';

    if (totalLabel) {
      totalLabel.textContent = 'Gesamtsumme';
      totalLabel.style.fontFamily = 'var(--font-body-family)';
      totalLabel.style.fontWeight = '400';
      totalLabel.style.fontSize = '15px';
      totalLabel.style.lineHeight = '1.3';
      totalLabel.style.whiteSpace = 'nowrap';
      totalLabel.style.margin = '0';
    }

    if (totalValue) {
      totalValue.style.fontFamily = 'var(--font-body-family)';
      totalValue.style.fontWeight = '400';
      totalValue.style.margin = '0';
      totalValue.style.whiteSpace = 'nowrap';
    }
  }

  function enhanceCart() {
    ensureFooterStyles();

    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    polishCartUi(drawer);

    const metaNode = drawer.querySelector('[data-lurello-cart-meta]');
    if (!metaNode || metaNode.dataset.lurelloApplied === 'true') return;

    let meta;
    try {
      meta = JSON.parse(metaNode.textContent);
    } catch (error) {
      return;
    }

    metaNode.dataset.lurelloApplied = 'true';

    (meta.items || []).forEach((item) => {
      const row = drawer.querySelector(`#CartDrawer-Item-${item.index}`);
      if (!row) return;

      row.classList.toggle('lurello-cart-item--sale', Boolean(item.hasSale));
      if (!item.hasSale || !item.unitOld) return;

      const priceBlock =
        row.querySelector('.cart-item__details > .cart-item__discounted-prices') ||
        row.querySelector('.cart-item__details > .product-option');

      if (!priceBlock) return;

      priceBlock.className = 'lurello-item-sale-prices';
      priceBlock.replaceChildren();

      addVisuallyHidden(priceBlock, 'Regulärer Preis');
      const oldPrice = document.createElement('s');
      oldPrice.className = 'lurello-price-old';
      oldPrice.textContent = item.unitOld;
      priceBlock.appendChild(oldPrice);

      addVisuallyHidden(priceBlock, 'Aktionspreis');
      const newPrice = document.createElement('strong');
      newPrice.className = 'lurello-price-new';
      newPrice.textContent = item.unitNew;
      priceBlock.appendChild(newPrice);
    });

    const totalsRow = drawer.querySelector('.cart-drawer__footer .totals');
    const totalLabel = totalsRow?.querySelector('.totals__total');
    const totalValue = totalsRow?.querySelector('.totals__total-value');
    const footer = totalsRow?.parentElement;

    footer?.querySelectorAll('.lurello-cart-savings').forEach((node) => node.remove());
    styleSimpleTotal(totalsRow, totalLabel, totalValue);

    if (meta.hasSavings && totalValue) {
      totalValue.replaceChildren();

      const stack = document.createElement('span');
      stack.className = 'lurello-cart-total-price-stack';
      stack.style.display = 'inline-flex';
      stack.style.alignItems = 'baseline';
      stack.style.justifyContent = 'flex-end';
      stack.style.flexWrap = 'nowrap';
      stack.style.gap = '8px';
      stack.style.whiteSpace = 'nowrap';
      stack.style.fontFamily = 'var(--font-body-family)';
      stack.style.fontWeight = '400';

      const oldTotal = document.createElement('s');
      oldTotal.className = 'lurello-cart-total-old';
      oldTotal.textContent = meta.compareTotal;
      oldTotal.style.fontFamily = 'var(--font-body-family)';
      oldTotal.style.fontWeight = '400';
      oldTotal.style.fontSize = '13px';
      oldTotal.style.whiteSpace = 'nowrap';

      const newTotal = document.createElement('span');
      newTotal.className = 'lurello-cart-total-new';
      newTotal.textContent = meta.total;
      newTotal.style.fontFamily = 'var(--font-body-family)';
      newTotal.style.fontWeight = '700';
      newTotal.style.fontSize = '16px';
      newTotal.style.whiteSpace = 'nowrap';

      stack.append(oldTotal, newTotal);
      totalValue.appendChild(stack);
    }
  }

  function queueEnhancement() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhanceCart();
    });
  }

  ensureFooterStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueEnhancement, { once: true });
  } else {
    queueEnhancement();
  }

  const observer = new MutationObserver(queueEnhancement);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
